import { AspectRatio, Image, AspectRatioProps } from "@chakra-ui/react";
import { publicUrl, v1FilesUrl } from "config";
import { ImageSize } from "types";

type V1ImageProps = Omit<AspectRatioProps, "ratio"> & {
  tokenId?: number;
  size?: ImageSize;
  isDisabled?: boolean;
  withV2Badge?: boolean;
};

const V1Image = ({
  tokenId,
  size = "512",
  isDisabled = false,
  withV2Badge = false,
  ...rest
}: V1ImageProps) => (
  <AspectRatio
    ratio={1}
    w="full"
    bg="dark.400"
    borderRadius="md"
    overflow="hidden"
    position="relative"
    opacity={isDisabled ? 0.5 : 1}
    transition="opacity 0.15s"
    {...rest}
  >
    <>
      <Image
        fit="cover"
        src={
          Number.isInteger(tokenId)
            ? `${v1FilesUrl}/${size !== "full" ? `${size}/` : ""}${tokenId}.png`
            : undefined
        }
        fallbackSrc={`${publicUrl}/v2-placeholder_transparent.png`}
      />
      {withV2Badge && <Image src={`${publicUrl}/v2-badge.png`} fit="cover" />}
    </>
  </AspectRatio>
);

export default V1Image;
